import { PureQueryOptions, RefetchQueriesFunction } from '@apollo/client';
import { IconComponentProps } from '@bechtel/gds';
import {
  CommodityMilestone,
  CommodityMilestoneActivity,
  CommodityStatusCode,
  MilestoneStatusCode,
  PersonaType,
  ProjectMilestoneType,
  Weld,
} from '@bechtel/types';

export enum MilestoneStatusExtended {
  BLOCKED = 'BLOCKED',
}

export type MilestoneStatusExt = MilestoneStatusCode | MilestoneStatusExtended;

export interface WeldAttachmentActionProps {
  status: MilestoneStatusExt;
  milestone: CommodityMilestone;
  isInverted?: boolean;
}

export interface WeldActionProps {
  milestone: CommodityMilestone;
  status: CommodityStatusCode;
  weldCommodity?: Weld;
  actionText?: string;
  openBlockSidesheet?: () => void;
  disabled?: boolean;
  refetchQueries?: (string | PureQueryOptions)[] | RefetchQueriesFunction;
  customStyle?: React.CSSProperties;
  onActionUpdating?: () => void;
  onActionCompleted?: () => void;
  personaType?: PersonaType;
  openSendBackSideSheet?: () => void;
  fitupProjectMilestoneDetails?: ProjectMilestoneType;
  latestClaimedFitupMilestoneActivity?: CommodityMilestoneActivity;
  latestClaimedInstallMilestoneActivity?: CommodityMilestoneActivity;
}
export interface WeldStyledProps {
  isBlocked?: boolean;
  isInverted?: boolean;
  status: CommodityStatusCode;
  onClick?: () => void;
}

export interface WeldActionContentProps {
  label: string;
  icon: IconComponentProps['icon'];
}

export interface WeldNonActionProps {
  label: string;
  icon: IconComponentProps['icon'];
}
export interface WeldSendBackProps {
  disabled?: boolean;
  weldCommodity?: Weld;
  openSendBackSideSheet?: () => void;
}
